/**
 * Safe logger utility that provides fallback to console methods
 * when window.rules_engine.logger is not available
 */
export const getLogger = () => {
  return window.rules_engine?.logger || createConsoleLogger()
}

/**
 * Creates a console-based logger fallback
 */
const createConsoleLogger = () => ({
  // eslint-disable-next-line no-console
  info: (...args) => console.info(...args),
  // eslint-disable-next-line no-console
  error: (...args) => console.error(...args),
  // eslint-disable-next-line no-console
  warn: (...args) => console.warn(...args),
  // eslint-disable-next-line no-console
  debug: (...args) => console.debug(...args),
})

/**
 * Convenience methods for direct logging
 */
export const logger = {
  info: (...args) => getLogger().info(...args),
  error: (...args) => getLogger().error(...args),
  warn: (...args) => getLogger().warn(...args),
  debug: (...args) => getLogger().debug(...args),
}

/**
 * Format and log Axios HTTP errors with structured data
 * @param {Object} error Axios HTTP Error object
 */
export function formatAndLogError(error) {
  const dataInfo = {
    message: error.message,
    response: error.response?.data?.detail,
    responseURL: error.request?.responseURL,
  }
  getLogger().error(error.message, dataInfo, error.stack)
}
